<div class="site">
  <div class="image">
    <div>
      <img [src]="logo"/>
    </div>
  </div>
  <div class="text">
    <div class="app-html-block" [innerHtml]="content"></div>
    <a [routerLink]="path">
      <button type='button' class="regular button solid-green {{path}}-learn-more">
      Learn More <span class="icon">&#xf3d1;</span>
      </button>
    </a>
  </div>
</div>
<hr/>
